import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import api from "@/lib/api";
import { ArrowLeft, Calendar, User } from "lucide-react";

function fmtDate(iso) { try { return new Date(iso).toLocaleDateString("id-ID", { day: "numeric", month: "long", year: "numeric" }); } catch { return ""; } }

export default function BeritaDetail() {
  const { slug } = useParams();
  const [b, setB] = useState(null);
  const [err, setErr] = useState("");
  useEffect(() => { api.get(`/berita/${slug}`).then((r) => setB(r.data)).catch(() => setErr("Berita tidak ditemukan")); }, [slug]);

  if (err) return <div className="max-w-3xl mx-auto py-24 px-4 text-center text-[#003A5C]">{err}</div>;
  if (!b) return <div className="max-w-3xl mx-auto py-24 px-4 text-center text-[#003A5C]">Memuat...</div>;

  return (
    <div>
      <div className="relative h-[50vh] overflow-hidden">
        <img src={b.cover} alt={b.judul} className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-t from-[#003A5C]/95 via-[#003A5C]/50 to-transparent" />
        <div className="relative max-w-4xl mx-auto px-4 h-full flex flex-col justify-end pb-10">
          <Link to="/informasi/berita" className="inline-flex items-center gap-2 text-white/80 hover:text-white text-sm mb-4"><ArrowLeft className="w-4 h-4" /> Semua Berita</Link>
          <span className="inline-block self-start text-[10px] uppercase tracking-widest font-bold px-3 py-1 rounded-full bg-[#00B4D8] text-white mb-3">{b.kategori}</span>
          <h1 className="font-heading font-bold text-white text-3xl lg:text-5xl leading-tight max-w-3xl">{b.judul}</h1>
        </div>
      </div>
      <article className="max-w-3xl mx-auto px-4 py-12">
        <div className="flex flex-wrap items-center gap-4 text-sm text-slate-500 mb-8 pb-6 border-b border-slate-200">
          <div className="inline-flex items-center gap-2"><Calendar className="w-4 h-4" /> {fmtDate(b.tanggal)}</div>
          <div className="inline-flex items-center gap-2"><User className="w-4 h-4" /> {b.penulis}</div>
        </div>
        <p className="text-lg text-slate-700 leading-relaxed mb-6">{b.excerpt}</p>
        {b.konten.split("\n\n").map((p, i) => (
          <p key={i} className="text-slate-700 leading-relaxed mb-4 whitespace-pre-line">{p}</p>
        ))}
      </article>
    </div>
  );
}
